import type { LandingLocale } from './landingContentTypes.js';
import { isIndustryPageKey, type IndustryPageKey } from './industryPages.js';
import type { StaticPageContent } from './staticPageContent.js';

const backgroundWords: Record<LandingLocale, Partial<Record<IndustryPageKey, string>>> = {
  de: { pflege: 'Pflege', einzelhandel: 'Einzelhandel', handwerk: 'Handwerk', gastro: 'Gastronomie', elektriker: 'Elektro', bauwesen: 'Bauwesen', schweisser: 'Schweißen', cnc: 'CNC', shk: 'SHK', 'lkw-fahrer': 'Logistik' },
  en: { pflege: 'Care', einzelhandel: 'Retail', handwerk: 'Trades', gastro: 'Hospitality', elektriker: 'Electrical', bauwesen: 'Construction', schweisser: 'Welding', cnc: 'CNC', shk: 'HVAC', 'lkw-fahrer': 'Logistics' },
  tr: { pflege: 'Bakım', einzelhandel: 'Perakende', handwerk: 'Zanaat', gastro: 'Gastronomi', elektriker: 'Elektrik', bauwesen: 'İnşaat', schweisser: 'Kaynak', cnc: 'CNC', shk: 'Tesisat', 'lkw-fahrer': 'Lojistik' },
};

const highlightWords: Record<LandingLocale, Partial<Record<IndustryPageKey, readonly string[]>>> = {
  de: {
    pflege: ['Zukunft', 'Pflege'], einzelhandel: ['Kundennähe', 'Einzelhandel'], handwerk: ['Zukunft', 'Handwerk'],
    gastro: ['Teams', 'Service'], elektriker: ['Elektroniker', 'Elektriker'], bauwesen: ['Zukunft', 'Bauwesen'],
    schweisser: ['verbindet', 'Schweißer'], cnc: ['Präzision', 'CNC'], shk: ['Klima', 'Zukunft'], 'lkw-fahrer': ['Zukunft', 'Straße'],
  },
  en: {
    pflege: ['future', 'care'], einzelhandel: ['Retail'], handwerk: ['future', 'trades'], gastro: ['teams', 'service'],
    elektriker: ['electrical', 'electronics'], bauwesen: ['future', 'Construction'], schweisser: ['connections', 'Welding'],
    cnc: ['Precision', 'CNC'], shk: ['cooling', 'future'], 'lkw-fahrer': ['future', 'Truck'],
  },
  tr: {
    pflege: ['geleceği', 'bakım'], einzelhandel: ['Perakendeyi', 'Perakende'], handwerk: ['geleceği', 'zanaati', 'Zanaatte'],
    gastro: ['ekipleri', 'servis'], elektriker: ['geleceğin', 'Elektrik'], bauwesen: ['Geleceğini', 'İnşaat'],
    schweisser: ['Ustalığınla', 'Kaynakçılık'], cnc: ['Hassasiyetle', 'CNC'], shk: ['geleceğin', 'klima'], 'lkw-fahrer': ['Geleceğini', 'şoförlüğü'],
  },
};

export const industryHeroPresentation = (page: StaticPageContent, locale: LandingLocale): StaticPageContent => {
  if (!isIndustryPageKey(page.key)) return page;
  const title = page.title.toLocaleLowerCase(locale);
  const highlight = highlightWords[locale][page.key]?.find(word => title.includes(word.toLocaleLowerCase(locale)));
  return {
    ...page,
    heroTitleHighlight: page.heroTitleHighlight ?? highlight ?? page.title.trim().match(/\S+$/u)?.[0] ?? '',
    heroBackgroundWord: page.heroBackgroundWord ?? backgroundWords[locale][page.key],
  };
};
